import { Link } from "react-router-dom";
import "./Footer.css";

import waiaLogo2 from "@/assets/logos/waia-logo-2.webp";
import { linkedin, youtube } from "@/assets";
import { useEasterEgg } from "@/hooks/useEasterEgg";
import { useLocale } from "@/i18n/useLocale";

function Footer() {
  const { t, path } = useLocale();
  const handleLogoClick = useEasterEgg(5, 1000);

  // Links de texto reales (<a href>, no botones ni JS): el footer era la unica
  // zona sin navegacion y las paginas profundas solo se alcanzaban desde el
  // menu. Mismos nombres que el menu; "Industrias" no esta en el menu, sale de
  // su propio indice.
  const links = [
    { to: path("solutions"), label: t.nav.solutions },
    { to: path("industries"), label: t.industries.indexTitle },
    { to: path("cases"), label: t.nav.cases },
    { to: path("enterprise"), label: t.nav.enterprise },
    { to: path("news"), label: t.nav.news },
    { to: path("about"), label: t.nav.about },
    { to: `${path("home")}#contacto`, label: t.nav.contact },
  ];

  return (
    <footer className="footer">
      <div className="footer__content">
        <div className="footer__brand">
          <img
            src={waiaLogo2}
            loading="lazy"
            alt="WAIA"
            title="WAIA"
            className="footer__logo"
            onClick={handleLogoClick}
            style={{ cursor: "pointer", userSelect: "none" }}
          />
        </div>

        <div className="footer__social">
          <a href="https://www.linkedin.com/company/72595080/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" title="WAIA en LinkedIn" className="footer__social-link">
            <img src={linkedin} loading="lazy" alt="" aria-hidden="true" />
          </a>
          <a href="https://www.instagram.com/somoswaia/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" title="WAIA en Instagram" className="footer__social-link">
            <svg viewBox="0 0 24 24" fill="white" width="22" height="22" style={{ display: 'block' }}>
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
            </svg>
          </a>

          <a href="https://www.youtube.com/@somoswaia" aria-label="YouTube" title="WAIA en YouTube" className="footer__social-link">
            <img src={youtube} loading="lazy" alt="" aria-hidden="true" />
          </a>
        </div>
      </div>

      <nav className="footer__nav" aria-label={t.footer.navLabel}>
        <ul className="footer__nav-list">
          {links.map((link) => (
            <li key={link.to}>
              <Link to={link.to} className="footer__nav-link">
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* llms.txt ya existe en /llms.txt (formato plano, no HTML: es lo que
          mejor parsean los agentes/LLMs), pero sin este link nadie lo
          encuentra salvo que escriba la URL a mano. */}
      <div className="footer__agent">
        <a href="/llms.txt" className="footer__agent-link">
          {t.footer.agentLink}
        </a>
      </div>
    </footer>
  );
}

export default Footer;